import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enOrders from './locales/en/orders.json';
import enReceipts from './locales/en/receipts.json';
import enErrors from './locales/en/errors.json';
import zhCommon from './locales/zh/common.json';
import zhOrders from './locales/zh/orders.json';
import zhReceipts from './locales/zh/receipts.json';
import zhErrors from './locales/zh/errors.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...enCommon, ...enOrders, ...enReceipts, ...enErrors } },
      zh: { translation: { ...zhCommon, ...zhOrders, ...zhReceipts, ...zhErrors } },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
